// Leanbot toolkit bar: hand the signed-in user to the shared bar (public/ptv-toolkit-host.js sets the rest).
// Never throws; a no-op when the bar is not loaded (404, kill switch, framed page).
export interface ToolkitUser { name?: string; login?: string }

export function publishToolkitUser(user: ToolkitUser | null | undefined, win: any = typeof window !== 'undefined' ? window : undefined): boolean {
  try {
    if (!win || !user || !(user.name || user.login)) return false;
    const patch = { user: { name: String(user.name || user.login), login: String(user.login || '') } };
    const cfg = win.PTV_TOOLKIT || (win.PTV_TOOLKIT = {});
    Object.assign(cfg, patch);
    win.dispatchEvent(new win.CustomEvent('ptv-toolkit:config', { detail: patch }));
    return true;
  } catch (e) {
    return false;
  }
}
